<app-card
  class="flex-basis-100 mb-12"
  *ngIf="hasGeneralInfo(metadata) || hasGeneralInfo(originalMetadata)"
>
  <div cardTitle i18n>Informations générales</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="metadata?.startDate || originalMetadata?.startDate"
      >
        <span class="card__label" i18n>Date de début</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                (originalMetadata?.startDate | customDate) !==
                  (metadata.startDate | customDate),
            }"
            >{{ metadata.startDate | customDate }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              (originalMetadata?.startDate | customDate) !==
                (metadata.startDate | customDate) &&
              (originalMetadata?.startDate | customDate) !== null &&
              (originalMetadata?.startDate | customDate) !== undefined
            "
            >{{ originalMetadata?.startDate | customDate }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.contractDuration || originalMetadata?.contractDuration"
      >
        <span class="card__label" i18n>Durée du contrat</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.contractDuration !==
                  metadata.contractDuration,
            }"
            >{{ metadata.contractDuration }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.contractDuration !==
                metadata.contractDuration &&
              originalMetadata?.contractDuration !== null &&
              originalMetadata?.contractDuration !== undefined
            "
            >{{ originalMetadata?.contractDuration }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.paymentFrequency !== undefined &&
            metadata?.paymentFrequency !== null) ||
          (originalMetadata?.paymentFrequency !== undefined &&
            originalMetadata?.paymentFrequency !== null)
        "
      >
        <span class="card__label" i18n>Mode de paiement</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getPaymentFrequencyLabel(originalMetadata?.paymentFrequency) !==
                  getPaymentFrequencyLabel(metadata.paymentFrequency),
            }"
            >{{ getPaymentFrequencyLabel(metadata.paymentFrequency) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getPaymentFrequencyLabel(originalMetadata?.paymentFrequency) !==
                getPaymentFrequencyLabel(metadata.paymentFrequency) &&
              getPaymentFrequencyLabel(originalMetadata?.paymentFrequency) !==
                null &&
              getPaymentFrequencyLabel(originalMetadata?.paymentFrequency) !==
                undefined
            "
            >{{
              getPaymentFrequencyLabel(originalMetadata?.paymentFrequency)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.splitPaymentFee !== undefined &&
            metadata?.splitPaymentFee !== null) ||
          (originalMetadata?.splitPaymentFee !== undefined &&
            originalMetadata?.splitPaymentFee !== null)
        "
      >
        <span class="card__label" i18n
          >Supplément pour paiement fractionné</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.splitPaymentFee !== metadata.splitPaymentFee,
            }"
            >{{ metadata.splitPaymentFee }} %</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.splitPaymentFee !== metadata.splitPaymentFee &&
              originalMetadata?.splitPaymentFee !== null &&
              originalMetadata?.splitPaymentFee !== undefined
            "
            >{{ originalMetadata?.splitPaymentFee }} %</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.policyType !== undefined &&
            metadata?.policyType !== null) ||
          (originalMetadata?.policyType !== undefined &&
            originalMetadata?.policyType !== null)
        "
      >
        <span class="card__label" i18n>Genre de police</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBusinessTransportPolicyTypeLabel(
                  originalMetadata?.policyType
                ) !== getBusinessTransportPolicyTypeLabel(metadata.policyType),
            }"
            >{{
              getBusinessTransportPolicyTypeLabel(metadata.policyType)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBusinessTransportPolicyTypeLabel(
                originalMetadata?.policyType
              ) !== getBusinessTransportPolicyTypeLabel(metadata.policyType) &&
              getBusinessTransportPolicyTypeLabel(
                originalMetadata?.policyType
              ) !== null &&
              getBusinessTransportPolicyTypeLabel(
                originalMetadata?.policyType
              ) !== undefined
            "
            >{{
              getBusinessTransportPolicyTypeLabel(originalMetadata?.policyType)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.deductibleByCase !== undefined &&
            metadata?.deductibleByCase !== null) ||
          (originalMetadata?.deductibleByCase !== undefined &&
            originalMetadata?.deductibleByCase !== null)
        "
      >
        <span class="card__label" i18n>Franchise par cas</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.deductibleByCase !==
                  metadata.deductibleByCase,
            }"
            >{{ metadata.deductibleByCase }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.deductibleByCase !==
                metadata.deductibleByCase &&
              originalMetadata?.deductibleByCase !== null &&
              originalMetadata?.deductibleByCase !== undefined
            "
            >{{ originalMetadata?.deductibleByCase }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.coverages || originalMetadata?.coverages"
      >
        <span class="card__label" i18n>Couverture d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.coverages !== metadata.coverages,
            }"
            >{{ metadata.coverages }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.coverages !== metadata.coverages &&
              originalMetadata?.coverages !== null &&
              originalMetadata?.coverages !== undefined
            "
            >{{ originalMetadata?.coverages }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.limitations || originalMetadata?.limitations"
      >
        <span class="card__label" i18n>Limitations</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.limitations !== metadata.limitations,
            }"
            >{{ metadata.limitations }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.limitations !== metadata.limitations &&
              originalMetadata?.limitations !== null &&
              originalMetadata?.limitations !== undefined
            "
            >{{ originalMetadata?.limitations }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isSectionEmpty(metadata?.insuranceSumByMeans) ||
    !isSectionEmpty(originalMetadata?.insuranceSumByMeans)
  "
>
  <div cardTitle i18n>Sommes d'assurance et moyen de transport</div>
  <div
    cardRows
    class="card__rows w-100"
    *ngIf="
      metadata?.insuranceSumByMeans || originalMetadata?.insuranceSumByMeans
    "
  >
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata.insuranceSumByMeans.insuranceSumRailroad !== undefined &&
            metadata.insuranceSumByMeans.insuranceSumRailroad !== null) ||
          (originalMetadata?.insuranceSumByMeans.insuranceSumRailroad !==
            undefined &&
            originalMetadata?.insuranceSumByMeans.insuranceSumRailroad !== null)
        "
      >
        <span class="card__label" i18n>Par chemin de fer</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.insuranceSumByMeans.insuranceSumRailroad !==
                  metadata.insuranceSumByMeans.insuranceSumRailroad,
            }"
            >{{ metadata.insuranceSumByMeans.insuranceSumRailroad }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.insuranceSumByMeans.insuranceSumRailroad !==
                metadata.insuranceSumByMeans.insuranceSumRailroad &&
              originalMetadata?.insuranceSumByMeans.insuranceSumRailroad !==
                null &&
              originalMetadata?.insuranceSumByMeans.insuranceSumRailroad !==
                undefined
            "
            >{{
              originalMetadata?.insuranceSumByMeans.insuranceSumRailroad
            }}
            CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.insuranceSumByMeans.insuranceSumTruck !== undefined &&
            metadata.insuranceSumByMeans.insuranceSumTruck !== null) ||
          (originalMetadata?.insuranceSumByMeans.insuranceSumTruck !==
            undefined &&
            originalMetadata?.insuranceSumByMeans.insuranceSumTruck !== null)
        "
      >
        <span class="card__label" i18n
          >Par véhicule routier de camionneur professionel</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.insuranceSumByMeans.insuranceSumTruck !==
                  metadata.insuranceSumByMeans.insuranceSumTruck,
            }"
            >{{ metadata.insuranceSumByMeans.insuranceSumTruck }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.insuranceSumByMeans.insuranceSumTruck !==
                metadata.insuranceSumByMeans.insuranceSumTruck &&
              originalMetadata?.insuranceSumByMeans.insuranceSumTruck !==
                null &&
              originalMetadata?.insuranceSumByMeans.insuranceSumTruck !==
                undefined
            "
            >{{
              originalMetadata?.insuranceSumByMeans.insuranceSumTruck
            }}
            CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.insuranceSumByMeans.insuranceSumPlane !== undefined &&
            metadata.insuranceSumByMeans.insuranceSumPlane !== null) ||
          (originalMetadata?.insuranceSumByMeans.insuranceSumPlane !==
            undefined &&
            originalMetadata?.insuranceSumByMeans.insuranceSumPlane !== null)
        "
      >
        <span class="card__label" i18n>Par avion</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.insuranceSumByMeans.insuranceSumPlane !==
                  metadata.insuranceSumByMeans.insuranceSumPlane,
            }"
            >{{ metadata.insuranceSumByMeans.insuranceSumPlane }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.insuranceSumByMeans.insuranceSumPlane !==
                metadata.insuranceSumByMeans.insuranceSumPlane &&
              originalMetadata?.insuranceSumByMeans.insuranceSumPlane !==
                null &&
              originalMetadata?.insuranceSumByMeans.insuranceSumPlane !==
                undefined
            "
            >{{
              originalMetadata?.insuranceSumByMeans.insuranceSumPlane
            }}
            CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.insuranceSumByMeans.insuranceSumBoat !== undefined &&
            metadata.insuranceSumByMeans.insuranceSumBoat !== null) ||
          (originalMetadata?.insuranceSumByMeans.insuranceSumBoat !==
            undefined &&
            originalMetadata?.insuranceSumByMeans.insuranceSumBoat !== null)
        "
      >
        <span class="card__label" i18n>Par navire</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.insuranceSumByMeans.insuranceSumBoat !==
                  metadata.insuranceSumByMeans.insuranceSumBoat,
            }"
            >{{ metadata.insuranceSumByMeans.insuranceSumBoat }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.insuranceSumByMeans.insuranceSumBoat !==
                metadata.insuranceSumByMeans.insuranceSumBoat &&
              originalMetadata?.insuranceSumByMeans.insuranceSumBoat !== null &&
              originalMetadata?.insuranceSumByMeans.insuranceSumBoat !==
                undefined
            "
            >{{
              originalMetadata?.insuranceSumByMeans.insuranceSumBoat
            }}
            CHF</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isSectionEmpty(metadata?.insuranceSumLocal) ||
    !isSectionEmpty(originalMetadata?.insuranceSumLocal)
  "
>
  <div cardTitle i18n>
    Envois postaux à l'intérieur de la Suisse et du Liechtenstein
  </div>
  <div
    cardRows
    class="card__rows w-100"
    *ngIf="metadata?.insuranceSumLocal || originalMetadata?.insuranceSumLocal"
  >
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata.insuranceSumLocal.insuranceSumParcelSignature !==
            undefined &&
            metadata.insuranceSumLocal.insuranceSumParcelSignature !== null) ||
          (originalMetadata?.insuranceSumLocal.insuranceSumParcelSignature !==
            undefined &&
            originalMetadata?.insuranceSumLocal.insuranceSumParcelSignature !==
              null)
        "
      >
        <span class="card__label" i18n
          >Par colis postal avec prestation complémentaire"Signature"</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.insuranceSumLocal
                  .insuranceSumParcelSignature !==
                  metadata.insuranceSumLocal.insuranceSumParcelSignature,
            }"
            >{{
              metadata.insuranceSumLocal.insuranceSumParcelSignature
            }}
            CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.insuranceSumLocal
                .insuranceSumParcelSignature !==
                metadata.insuranceSumLocal.insuranceSumParcelSignature &&
              originalMetadata?.insuranceSumLocal
                .insuranceSumParcelSignature !== null &&
              originalMetadata?.insuranceSumLocal
                .insuranceSumParcelSignature !== undefined
            "
            >{{
              originalMetadata?.insuranceSumLocal.insuranceSumParcelSignature
            }}
            CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.insuranceSumLocal.insuranceSumRegistedLetter !==
            undefined &&
            metadata.insuranceSumLocal.insuranceSumRegistedLetter !== null) ||
          (originalMetadata?.insuranceSumLocal.insuranceSumRegistedLetter !==
            undefined &&
            originalMetadata?.insuranceSumLocal.insuranceSumRegistedLetter !==
              null)
        "
      >
        <span class="card__label" i18n>Par lettre"Recommandée"</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.insuranceSumLocal
                  .insuranceSumRegistedLetter !==
                  metadata.insuranceSumLocal.insuranceSumRegistedLetter,
            }"
            >{{
              metadata.insuranceSumLocal.insuranceSumRegistedLetter
            }}
            CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.insuranceSumLocal.insuranceSumRegistedLetter !==
                metadata.insuranceSumLocal.insuranceSumRegistedLetter &&
              originalMetadata?.insuranceSumLocal.insuranceSumRegistedLetter !==
                null &&
              originalMetadata?.insuranceSumLocal.insuranceSumRegistedLetter !==
                undefined
            "
            >{{
              originalMetadata?.insuranceSumLocal.insuranceSumRegistedLetter
            }}
            CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.insuranceSumLocal.insuranceSumSecurePost !== undefined &&
            metadata.insuranceSumLocal.insuranceSumSecurePost !== null) ||
          (originalMetadata?.insuranceSumLocal.insuranceSumSecurePost !==
            undefined &&
            originalMetadata?.insuranceSumLocal.insuranceSumSecurePost !== null)
        "
      >
        <span class="card__label" i18n>SecurePost, par colis</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.insuranceSumLocal.insuranceSumSecurePost !==
                  metadata.insuranceSumLocal.insuranceSumSecurePost,
            }"
            >{{ metadata.insuranceSumLocal.insuranceSumSecurePost }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.insuranceSumLocal.insuranceSumSecurePost !==
                metadata.insuranceSumLocal.insuranceSumSecurePost &&
              originalMetadata?.insuranceSumLocal.insuranceSumSecurePost !==
                null &&
              originalMetadata?.insuranceSumLocal.insuranceSumSecurePost !==
                undefined
            "
            >{{
              originalMetadata?.insuranceSumLocal.insuranceSumSecurePost
            }}
            CHF</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isSectionEmpty(metadata?.insuranceSumInternational) ||
    !isSectionEmpty(originalMetadata?.insuranceSumInternational)
  "
>
  <div cardTitle i18n>
    Envois postaux à destination/ en provenance de l'étranger
  </div>
  <div
    cardRows
    class="card__rows w-100"
    *ngIf="
      metadata?.insuranceSumInternational ||
      originalMetadata?.insuranceSumInternational
    "
  >
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata.insuranceSumInternational.insuranceSumParcel !==
            undefined &&
            metadata.insuranceSumInternational.insuranceSumParcel !== null) ||
          (originalMetadata?.insuranceSumInternational.insuranceSumParcel !==
            undefined &&
            originalMetadata?.insuranceSumInternational.insuranceSumParcel !==
              null)
        "
      >
        <span class="card__label" i18n>Par colis"PRIORITY / ECONOMY"</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.insuranceSumInternational
                  .insuranceSumParcel !==
                  metadata.insuranceSumInternational.insuranceSumParcel,
            }"
            >{{
              metadata.insuranceSumInternational.insuranceSumParcel
            }}
            CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.insuranceSumInternational.insuranceSumParcel !==
                metadata.insuranceSumInternational.insuranceSumParcel &&
              originalMetadata?.insuranceSumInternational.insuranceSumParcel !==
                null &&
              originalMetadata?.insuranceSumInternational.insuranceSumParcel !==
                undefined
            "
            >{{
              originalMetadata?.insuranceSumInternational.insuranceSumParcel
            }}
            CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.insuranceSumInternational.insuranceSumRegistedLetter !==
            undefined &&
            metadata.insuranceSumInternational.insuranceSumRegistedLetter !==
              null) ||
          (originalMetadata?.insuranceSumInternational
            .insuranceSumRegistedLetter !== undefined &&
            originalMetadata?.insuranceSumInternational
              .insuranceSumRegistedLetter !== null)
        "
      >
        <span class="card__label" i18n>Par lettre"Recommandée"</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.insuranceSumInternational
                  .insuranceSumRegistedLetter !==
                  metadata.insuranceSumInternational.insuranceSumRegistedLetter,
            }"
            >{{
              metadata.insuranceSumInternational.insuranceSumRegistedLetter
            }}
            CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.insuranceSumInternational
                .insuranceSumRegistedLetter !==
                metadata.insuranceSumInternational.insuranceSumRegistedLetter &&
              originalMetadata?.insuranceSumInternational
                .insuranceSumRegistedLetter !== null &&
              originalMetadata?.insuranceSumInternational
                .insuranceSumRegistedLetter !== undefined
            "
            >{{
              originalMetadata?.insuranceSumInternational
                .insuranceSumRegistedLetter
            }}
            CHF</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isSectionEmpty(metadata?.insuranceSumPostal) ||
    !isSectionEmpty(originalMetadata?.insuranceSumPostal)
  "
>
  <div cardTitle i18n>
    Envois par service de courrier, express et service de paquets postaux
  </div>
  <div
    cardRows
    class="card__rows w-100"
    *ngIf="metadata?.insuranceSumPostal || originalMetadata?.insuranceSumPostal"
  >
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata.insuranceSumPostal.insuranceSumParcel !== undefined &&
            metadata.insuranceSumPostal.insuranceSumParcel !== null) ||
          (originalMetadata?.insuranceSumPostal.insuranceSumParcel !==
            undefined &&
            originalMetadata?.insuranceSumPostal.insuranceSumParcel !== null)
        "
      >
        <span class="card__label" i18n>Par colis</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.insuranceSumPostal.insuranceSumParcel !==
                  metadata.insuranceSumPostal.insuranceSumParcel,
            }"
            >{{ metadata.insuranceSumPostal.insuranceSumParcel }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.insuranceSumPostal.insuranceSumParcel !==
                metadata.insuranceSumPostal.insuranceSumParcel &&
              originalMetadata?.insuranceSumPostal.insuranceSumParcel !==
                null &&
              originalMetadata?.insuranceSumPostal.insuranceSumParcel !==
                undefined
            "
            >{{
              originalMetadata?.insuranceSumPostal.insuranceSumParcel
            }}
            CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata.insuranceSumPostal.insuranceSumMerchandise !== undefined &&
            metadata.insuranceSumPostal.insuranceSumMerchandise !== null) ||
          (originalMetadata?.insuranceSumPostal.insuranceSumMerchandise !==
            undefined &&
            originalMetadata?.insuranceSumPostal.insuranceSumMerchandise !==
              null)
        "
      >
        <span class="card__label" i18n
          >Envois pour l'ensemble des marchandises pouvant se trouver en même
          temps</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata?.insuranceSumPostal.insuranceSumMerchandise !==
                  metadata.insuranceSumPostal.insuranceSumMerchandise,
            }"
            >{{ metadata.insuranceSumPostal.insuranceSumMerchandise }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata?.insuranceSumPostal.insuranceSumMerchandise !==
                metadata.insuranceSumPostal.insuranceSumMerchandise &&
              originalMetadata?.insuranceSumPostal.insuranceSumMerchandise !==
                null &&
              originalMetadata?.insuranceSumPostal.insuranceSumMerchandise !==
                undefined
            "
            >{{
              originalMetadata?.insuranceSumPostal.insuranceSumMerchandise
            }}
            CHF</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>
